var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7252 12.5498C15.6866 11.8597 16.3092 10.7935 16.4374 9.61702C16.5657 8.44074 16.1876 7.2653 15.3974 6.38429C14.6074 5.50338 13.4799 5 12.2964 5C11.1129 5 9.98547 5.50338 9.19538 6.38429C8.40519 7.26534 8.02712 8.44074 8.15544 9.61702C8.28361 10.7935 8.90615 11.8597 9.86759 12.5498C8.72291 13.0301 7.74533 13.8377 7.05741 14.8711C6.3695 15.9044 6.00157 17.1178 6 18.3591V19H18.593V18.3591C18.5914 17.1178 18.2235 15.9044 17.5356 14.8711C16.8477 13.8377 15.8701 13.0301 14.7254 12.5498H14.7252ZM9.42843 9.1949C9.42843 8.43001 9.73227 7.69661 10.2731 7.15573C10.8139 6.61485 11.5474 6.31105 12.3123 6.31105C13.0772 6.31105 13.8107 6.61488 14.3515 7.15573C14.8923 7.69661 15.1961 8.43001 15.1961 9.1949C15.1961 9.95979 14.8923 10.6933 14.3515 11.2341C13.8107 11.7749 13.0772 12.0788 12.3123 12.0788C11.5474 12.0788 10.8139 11.7749 10.2731 11.2341C9.73224 10.6933 9.42843 9.95979 9.42843 9.1949V9.1949ZM7.3232 17.7183C7.54793 16.1068 8.54054 14.7045 9.98576 13.957C11.4308 13.2094 13.1488 13.2094 14.5941 13.957C16.0391 14.7046 17.0317 16.1069 17.2565 17.7183H7.3232Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgents);
export default __webpack_public_path__ + "static/media/agents.b62d138af4c175d0568b25e1bf8ea20b.svg";
export { ForwardRef as ReactComponent };